import { ArrowDown, ArrowUp, CheckCircle2, ChevronRight, Layers } from "lucide-react";

export default function StageCard({
    stage,
    active = false,
    onClick,
    onMoveUp,
    onMoveDown,
    canMoveUp = false,
    canMoveDown = false,
}) {
    const nodeCount = stage.nodes?.length || 0;

    return (
        <div
            className={`group relative w-full rounded-2xl border text-left transition-all duration-200 ${active
                ? "border-[#74bde2] bg-[#edf8fe] shadow-[0_7px_18px_rgba(20,125,181,0.10)]"
                : "border-[#e1eaf3] bg-white hover:border-[#b9dcef] hover:shadow-[0_6px_16px_rgba(31,78,121,0.06)]"
                }`}
        >
            <button type="button" onClick={onClick} className="w-full p-3.5 pb-2.5 text-left">
                <div className="flex items-start justify-between gap-2">

                <div className="min-w-0 flex-1">

                    <div className="mb-1.5 flex items-center gap-2">
                        <span className={`text-[10px] font-bold uppercase tracking-[0.12em] ${active ? "text-[#1689c1]" : "text-[#8a9ab2]"}`}>Stage {stage.display_order}</span>
                        {stage.is_closed && <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[9px] font-bold text-emerald-700"><CheckCircle2 className="h-3 w-3" /> Closed</span>}
                    </div>

                    <h3
                        className={`line-clamp-2 text-[13px] font-bold leading-5 ${active
                            ? "text-[#0f5b8a]"
                            : "text-[#173552]"
                            }`}
                    >
                        {stage.name}
                    </h3>

                    <p className="mt-1 text-[11px] font-medium text-[#7b8da9]">{stage.probability ?? 0}% conversion probability</p>

                </div>

                <ChevronRight
                    size={18}
                    className={`mt-1 transition-transform ${active
                        ? "translate-x-1 text-[#147db5]"
                        : "text-[#9caec1] group-hover:translate-x-1"
                        }`}
                />

                </div>
            </button>

            <div className="mx-3.5 flex items-center justify-between border-t border-[#e8eff6] py-2.5">

                <div className="flex items-center gap-1.5 text-[11px] font-semibold text-[#6c7f9f]">

                    <Layers size={14} />

                    <span>
                        {nodeCount} action{nodeCount !== 1 ? "s" : ""}
                    </span>

                </div>

                <span className="flex items-center gap-0.5 opacity-0 transition group-hover:opacity-100 group-focus-within:opacity-100">
                    <button type="button" disabled={!canMoveUp} aria-label={`Move ${stage.name} earlier`} title="Move stage earlier" onClick={onMoveUp} className="rounded-md p-1 text-[#607b9f] hover:bg-white hover:text-[#147db5] disabled:cursor-not-allowed disabled:text-[#c9d4df]"><ArrowUp className="h-3.5 w-3.5" /></button>
                    <button type="button" disabled={!canMoveDown} aria-label={`Move ${stage.name} later`} title="Move stage later" onClick={onMoveDown} className="rounded-md p-1 text-[#607b9f] hover:bg-white hover:text-[#147db5] disabled:cursor-not-allowed disabled:text-[#c9d4df]"><ArrowDown className="h-3.5 w-3.5" /></button>
                </span>

            </div>

        </div>
    );
}
